import { render, staticRenderFns } from "./TabAnexos.vue?vue&type=template&id=73a6fc5a"
import script from "./TabAnexos.vue?vue&type=script&lang=js"
export * from "./TabAnexos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports